import React from 'react';
import CartItem from './CartItem';
import CartSummary from './CartSummary';
import Navbar from '../NavBar';
import Footer from '../Footer';   
import SectionBreak from '../SectionBreak';
import { useShop } from '../../context/ShopContext';

const CartPage = () => {
    const { cartItems, updateCartQuantity, removeFromCart, subtotal } = useShop();

    const handleQuantityChange = (itemId, newQuantity) => {
        updateCartQuantity(itemId, newQuantity);
    };

    const handleRemoveItem = (itemId) => {
        removeFromCart(itemId);
    };

    const tax = subtotal * 0.08; 
    const shipping = cartItems.length > 0 ? 5.99 : 0;

    return (
        <>
            <Navbar />
            <SectionBreak />
            <div className="container mx-auto max-w-6xl px-4 py-8">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 pb-4 gap-2">
                                <h2 className="text-lg font-semibold text-gray-900">Produkte</h2>
                                <div className="hidden sm:grid grid-cols-3 gap-8 text-xs tracking-wide text-gray-500 uppercase">
                                    <span>Sasia</span>
                                    <span className="text-right">Çmimi</span>
                                    <span className="text-right">Veprime</span>
                                </div>
                            </div>

                            {cartItems.length > 0 ? (
                                cartItems.map(item => (
                                    <CartItem
                                        key={item.id}
                                        item={item}
                                        onQuantityChange={handleQuantityChange}
                                        onRemove={handleRemoveItem}
                                    />
                                ))
                            ) : (
                                <div className="py-8 text-center text-gray-500">
                                    Shporta është bosh
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="lg:sticky lg:top-28">
                        <CartSummary
                            subtotal={subtotal}
                            tax={tax}
                            shipping={shipping}
                            isDisabled={cartItems.length === 0}
                        />
                    </div>
                </div>
            </div>
            <SectionBreak />
            <Footer />
        </>
    );
};

export default CartPage;